import Vue from "vue";
import jwt_decode from "jwt-decode";
import VueRouter from "vue-router";

import { changeLocale } from "@/utils/helpers/translation/translation.js";

import { login, getUserInfo, getMe } from "@/utils/api/usersApi.js";


import { isLogged, logout } from "@/utils/helpers/user.js";
import { getCookie, setCookie } from "@/utils/helpers/cookie";


import store from "../store/index";


Vue.use(VueRouter);

const requireAuth = function(to, from, next) {
    if(isLogged()) {
        next();
    } else {
        next("/login");
    }
};

const setLanguages = function(to, from, next) {
    const user = store.getters["userModule/getUser"];
    let cookieLocale = getCookie("LANGUAGE");

    // get current local from url params
    let locale = to.query.lang;

    if (locale === undefined || !locale.length) {
        if (user && user.language) {
            locale = user.language;
        } else if (cookieLocale !== undefined && cookieLocale.length) {
            locale = cookieLocale;
        } else {
            locale = "fr";
        }
    }

    if (user && user.astro) {
        locale += "-astro";
    }

    changeLocale(locale);
};

const routes = [
    /*{
        path: "/",
        alias: "/dashboard",
        name: "dashboard",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import( webpackChunkName: "dashboard-app"  "../views/pages/Dashboard.vue"),
        beforeEnter: (to, from, next) => {
            requireAuth(to, from, next);
        },
        meta: {
            hasTopNavigation: true,
            isInTopNavigation: true,
            isInDashboard: false,
            isDisabled: false,
            hideUsersSelectionInTopNav: true
        }
    },*/
    {
        path: "/",
        name: "today",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "today-app" */ "../views/pages/today/Today.vue"),
        beforeEnter: (to, from, next) => {
            requireAuth(to, from, next);
        },
        meta: {
            hasTopNavigation: true,
            isInTopNavigation: true,
            hideUsersSelectionInTopNav: true,
            isInDashboard: true,
            isDisabled: false,
            isPremiumOnly: false,
            description: "today-subtitle",
            dashboardArtwork: "today.svg",
            dashboardCallToAction: "today-dashboard-title"
        }
    },
    {
        path: "/widget",
        name: "widget",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "coaching-app" */ "../views/pages/widget/Widget.vue"),
        beforeEnter: (to, from, next) => {
            requireAuth(to, from, next);
        },
        meta: {
            hasTopNavigation: true,
            isInTopNavigation: false,
            isInDashboard: true,
            description: "coaching-subtitle",
            dashboardArtwork: "coaching.svg",
            isDisabled: false,
            isPremiumOnly: false,
            dashboardCallToAction: "coaching-dashboard-title"
        }
    },
    {
        path: "/momentum",
        name: "momentum",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "momentum-app" */ "../views/pages/momentum/Momentum.vue"),
        beforeEnter: (to, from, next) => {
            requireAuth(to, from, next);
        },
        props: true,
        meta: {
            hasTopNavigation: true,
            isInTopNavigation: true,
            isInDashboard: true,
            isDisabled: false,
            isPremiumOnly: true,
            description: "momentum-subtitle",
            dashboardArtwork: "momentum.svg",
            dashboardCallToAction: "momentum-dashboard-title"
        },
    },
    {
        path: "/barometer",
        name: "barometer",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "barometer-app" */ "../views/pages/barometer/Barometer.vue"),
        beforeEnter: (to, from, next) => {
            requireAuth(to, from, next);
        },
        meta: {
            hasTopNavigation: true,
            isInTopNavigation: true,
            isInDashboard: true,
            isDisabled: false,
            isPremiumOnly: true,
            description: "barometer-subtitle",
            dashboardArtwork: "barometer.svg",
            dashboardCallToAction: "barometer-dashboard-title"
        }
    },
    {
        path: "/profiling",
        name: "profiling",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "profiling-app" */ "../views/pages/profiling/Profiling.vue"),
        beforeEnter: (to, from, next) => {
            requireAuth(to, from, next);
        },
        props: true,
        meta: {
            hasTopNavigation: true,
            isInTopNavigation: true,
            isInDashboard: true,
            isDisabled: false,
            isPremiumOnly: true,
            description: "profiling-subtitle",
            dashboardArtwork: "profiling.svg",
            dashboardCallToAction: "profiling-dashboard-title"
        }
    },
    {
        path: "/matching",
        name: "matching",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "matching-app" */ "../views/pages/matching/Matching.vue"),
        beforeEnter: (to, from, next) => {
            requireAuth(to, from, next);
        },
        meta: {
            hasTopNavigation: true,
            isInTopNavigation: true,
            isInDashboard: true,
            isDisabled: false,
            isPremiumOnly: true,
            description: "matching-subtitle",
            dashboardArtwork: "matching.svg",
            dashboardCallToAction: "matching-dashboard-title"
        }
    },
    {
        path: "/in-depth",
        name: "in-depth",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "in-depth-app" */ "../views/pages/in-depth/InDepth.vue"),
        beforeEnter: (to, from, next) => {
            requireAuth(to, from, next);
        },
        meta: {
            hasTopNavigation: true,
            isInTopNavigation: false,
            isInDashboard: false,
            isDisabled: false,
            isPremiumOnly: true,
            description: "in-depth-subtitle",
            dashboardArtwork: "in-depth.svg",
            dashboardCallToAction: "in-depth-dashboard-title"
        },
    },
    {
        path: "/chart",
        name: "chart",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "chart-app" */ "../views/pages/chart/Chart.vue"),
        beforeEnter: (to, from, next) => {
            requireAuth(to, from, next);
        },
        props: true,
        meta: {
            hasTopNavigation: true,
            isInTopNavigation: true,
            isInDashboard: true,
            isDisabled: false,
            isPremiumOnly: false,
            description: "chart-subtitle",
            dashboardArtwork: "profiling.svg",
            dashboardCallToAction: "chart-dashboard-title"
        }
    },
    {
        path: "/coaching",
        name: "coaching",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "coaching-app" */ "../views/pages/coaching/Coaching.vue"),
        beforeEnter: (to, from, next) => {
            requireAuth(to, from, next);
        },
        meta: {
            hasTopNavigation: true,
            isInTopNavigation: false,
            isInDashboard: false,
            description: "coaching-subtitle",
            dashboardArtwork: "coaching.svg",
            isDisabled: true,
            isPremiumOnly: false,
            dashboardCallToAction: "coaching-dashboard-title"
        }
    },
   
    {
        path: "/user/profile",
        name: "profile",
        component: () => import(/* webpackChunkName: "user-app" */ "../views/pages/user/Profile.vue"),
        beforeEnter: (to, from, next) => {
            requireAuth(to, from, next);
        },
        props: route => ({
            loggedUser: store.getters["userModule/getUser"]
        }),
        meta: {
            hasTopNavigation: true
        }
    },
    {
        path: "/circles",
        name: "circles",
        component: () => import(/* webpackChunkName: "user-app" */ "../views/pages/Circles.vue"),
        beforeEnter: (to, from, next) => {
            requireAuth(to, from, next);
        },
        meta: {
            hideUsersSelectionInTopNav: true
        }
    },
    {
        path: "/signup",
        name: "signup",
        component: () => import(/* webpackChunkName: "user-app" */ "../views/pages/user/Signup.vue"),
        beforeEnter: (to, from, next) => {
            if (isLogged()) {
                next(false);
            } else {
                next();
            }
        },
        meta: {
            hasTopNavigation: true
        }
    },
    {
        path: "/login",
        name: "login",
        component: () => import(/* webpackChunkName: "user-app" */ "../views/pages/user/Login.vue"),
        beforeEnter: (to, from, next) => {
            if (isLogged()) {
                next(false);
            } else {
                next();
            }
        },
        meta: {
            hasTopNavigation: false
        }
    },
    {
        path: "/forgot-password",
        name: "forgot-password",
        component: () => import(/* webpackChunkName: "user-app" */ "../views/pages/user/ForgotPassword.vue"),
        beforeEnter: (to, from, next) => {
            if (isLogged()) {
                next(false);
            } else {
                next();
            }
        }
    },
    {
        path: "/reset-password",
        name: "reset-password",
        component: () => import(/* webpackChunkName: "user-app" */ "../views/pages/user/ResetPassword.vue"),
        beforeEnter: (to, from, next) => {
            if (!to.query.token) {
                next("/login");
            }

            if (isLogged()) {
                next(false);
            } else {
                next();
            }
        },
        props: route => ({
            token: route.query.token
        }),
    },
    {
        path: "/logout",
        name: "logout",
        beforeEnter: (to, from, next) => {
            logout();
            router.replace("/login");
        }
    },
    {
        path: "*",
        name: "404",
        redirect: "/"
    }
];

const router = new VueRouter({
    routes,
    scrollBehavior (to, from, savedPosition) {
        if (to.hash) {
            return {
                selector: to.hash
            };
        }

        if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    }
});

router.beforeEach((to, from, next) => {
    const user = store.getters["userModule/getUser"];
    const cookieToken = getCookie("jwt_token");

    if (isLogged()) {

        setLanguages(to, from, next);

        if (to.meta.isDisabled || (to.meta.isPremiumOnly && !user.userpremium)) {
            next("/");
        }

        next();
    } else if (process.env.VUE_APP_ENVIRONMENT_NAME === "local" && cookieToken) {
        // There is a cookie token, auto log the user
        const decodedToken = jwt_decode(cookieToken);

        const loginInfo = {
            "id": decodedToken.userId,
            "token": cookieToken
        };

        getUserInfo(loginInfo).then((res) => {

            if (res.status === 200 && res.data) {

                const userInfo = res.data;

                getMe(loginInfo).then((res) => {
                    if (res.status === 200 && res.data) {
                        store.commit("userModule/setUser", userInfo);
                        store.commit("userModule/setToken", loginInfo.token);
                        store.commit("userModule/setPersonality", res.data);

                        // Temporary save JWT token in a cookie
                        // WARNING: That's not secure at all, and we will update that with a proper persistent JWT strategy further
                        let isCookieSecure = true;
                        if (process.env.VUE_APP_ENVIRONMENT_NAME === "local") {
                            isCookieSecure = false;
                        }

                        setCookie("jwt_token", loginInfo.token, {"path": "/", "domain": process.env.VUE_APP_ROOT_URL, "httponly": false, "expires": 525600, "samesite": "Strict", "secure": isCookieSecure});

                        setLanguages(to, from, next);

                        next();
                    } else {
                        throw (res);
                    }
                });
            } else {
                // Handle Error
                setLanguages(to, from, next);
                throw (res);
            }
        });
    } else {
        // User is not logged and there was not cookie session
        setLanguages(to, from, next);
        next();
    }
});

export default router;
